const VOUCHER_THEME_CLASS_NAME_MAP: Partial<Record<App.VoucherTheme, string>> = {
  luxplus: 'theme-luxplus',
  societe: 'theme-societe',
  'societe-bronze': 'theme-societe-bronze',
  'societe-silver': 'theme-societe-silver',
  'societe-gold': 'theme-societe-gold',
  'societe-platinum': 'theme-societe-platinum',
}

export default function getVoucherThemeClassName(theme?: App.VoucherTheme): string | undefined {
  return theme ? VOUCHER_THEME_CLASS_NAME_MAP[theme] : undefined
}
